import React from 'react'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import StatusFireExtinguisher from './Status'
import TaxOutgoing from './Tax'
import PaymentOutgoing from './ModeofPayment'
import CategoryOutgoing from './Category'
import StatusOutgoing from './Status'
import Division from './Division'
import PaymentTerm from './paymentTerm'
import { ReceiptText } from 'lucide-react'
import { HeadingWithIcon } from '../../../../../Components/Utils/Settingheading'

function OutgoingSettings() {
    return(
        <>
        
                     <HeadingWithIcon icon={ReceiptText} title="Invoice-Outgoing" />

        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        
        <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <TaxOutgoing/>
         </div>
         {/* <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <PaymentOutgoing/>
         </div> */}
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <CategoryOutgoing/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <Division/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <PaymentTerm />
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <StatusOutgoing/>
         </div>
        
       
         </div>
         </>
    )
}

export default OutgoingSettings
